export const isObjectArray = (obj) => {
    return obj !== undefined && Array.isArray(obj) && obj.length > 0;
};

export const getNoOfBooksPerContainer = () => {
    return (window.screen.width <= 576) ? 1 : 4;
}


export const isJSON = (str) => {
    if (typeof str !== "string") {
        return false;
    }
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};